import { apiPlugin, storyblokInit } from "@storyblok/react/rsc";

import Page from "@/components/Page";

import FomaHero from '@/components/FomaHero'
import ImageText from '@/components/ImageText'
import Slider from '@/components/Slider'
import ImageGrid from '@/components/ImageGrid'
import ImageGridItem from '@/components/ImageGridItem'
import RichText from '@/components/RichText'
import TwoColumn from '@/components/TwoColumn'
import contactForm from '@/components/ContactForm'
import Map from '@/components/Map'
import Video from '@/components/Video'
import Parallax from '@/components/Parallax'
import Timeline from '@/components/Timeline'
import Seo from '@/components/Seo'

export const getStoryblokApi = storyblokInit({
  // Server only: the preview token reads drafts and is not sent to the browser
  // (no NEXT_PUBLIC_). There this file is loaded for the component list alone —
  // the editor's live update goes through a server action, not the API.
  accessToken: process.env.STORYBLOK_PREVIEW_TOKEN,
  use: process.env.STORYBLOK_PREVIEW_TOKEN ? [apiPlugin] : [],
  components: {
    page: Page,
    fomaHero: FomaHero,
    imageText: ImageText,
    slider: Slider,
    imageGrid: ImageGrid,
    imageGridItem: ImageGridItem,
    richText: RichText,
    twoColumn: TwoColumn,
    contactForm: contactForm,
    map: Map,
    video: Video,
    parallax: Parallax,
    timeline: Timeline,
    seo: Seo,
  },
});
